import MenuOnSelectionModal from './MenuOnSelectionModal';

export default MenuOnSelectionModal;
